/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { PaginatedResponseSupportRequestResponseDTOFromJSON, SupportRequestAdminUpdateDTOToJSON, SupportRequestCreateUpdateDTOToJSON, SupportRequestResponseDTOFromJSON, } from '../models/index';
/**
 *
 */
export class SupportRequestControllerApi extends runtime.BaseAPI {
    /**
     */
    async _deleteRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling _delete().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/support-requests/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async _delete(requestParameters, initOverrides) {
        await this._deleteRaw(requestParameters, initOverrides);
    }
    /**
     */
    async createRequestRaw(requestParameters, initOverrides) {
        if (requestParameters['supportRequestCreateUpdateDTO'] == null) {
            throw new runtime.RequiredError('supportRequestCreateUpdateDTO', 'Required parameter "supportRequestCreateUpdateDTO" was null or undefined when calling createRequest().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/support-requests`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestCreateUpdateDTOToJSON(requestParameters['supportRequestCreateUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRequestResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createRequest(requestParameters, initOverrides) {
        const response = await this.createRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getAllRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/support-requests`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseSupportRequestResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getAll(requestParameters = {}, initOverrides) {
        const response = await this.getAllRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOneRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getOne().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/support-requests/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRequestResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getOne(requestParameters, initOverrides) {
        const response = await this.getOneRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateByAdminRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateByAdmin().');
        }
        if (requestParameters['supportRequestAdminUpdateDTO'] == null) {
            throw new runtime.RequiredError('supportRequestAdminUpdateDTO', 'Required parameter "supportRequestAdminUpdateDTO" was null or undefined when calling updateByAdmin().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/support-requests/{id}/admin`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestAdminUpdateDTOToJSON(requestParameters['supportRequestAdminUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRequestResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateByAdmin(requestParameters, initOverrides) {
        const response = await this.updateByAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateByUserRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateByUser().');
        }
        if (requestParameters['supportRequestCreateUpdateDTO'] == null) {
            throw new runtime.RequiredError('supportRequestCreateUpdateDTO', 'Required parameter "supportRequestCreateUpdateDTO" was null or undefined when calling updateByUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/support-requests/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestCreateUpdateDTOToJSON(requestParameters['supportRequestCreateUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRequestResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateByUser(requestParameters, initOverrides) {
        const response = await this.updateByUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
